import { ResponsiveGutter } from './types';

export const DEFAULT_GUTTER: ResponsiveGutter = { xs: 8, sm: 16, md: 24 };
export const DASHBOARD_GUTTER: ResponsiveGutter = { xs: 8, sm: 16 };
